import React from "react";

/** An agent wrote it: only a web or mail address opens, in a new tab; anything else (a
    `javascript:` URL above all) stays its words. */
export default function Link({ href, children }: { href: string; children: React.ReactNode }) {
  if (!/^(https?:|mailto:)/i.test(href)) return <span>{children}</span>;
  return (
    <a href={href} target="_blank" rel="noreferrer" className="text-[var(--text-primary)] underline decoration-[var(--text-quaternary)] underline-offset-2 hover:decoration-[var(--text-primary)]">
      {children}
    </a>
  );
}
